import React from 'react';

function UserInitialsCircle({ user }) {
	const name = `${(user?.first_name ?? '')[0]}${(user?.last_name ?? '')[0]}`;
	return (
		<div className='bg-[#B8B8D6] h-[28px] w-[28px] rounded-full flex items-center justify-center font-bold text-[12px] leading-4'>
			{name}
		</div>
	);
}

export default UserInitialsCircle;
